import { Route, Routes } from 'react-router-dom';
import EntraIdSuccess from './containers/entraId/EntraIdSuccess';
import { PortalLanding } from './containers/landing/PortalLanding';
import Settings from './containers/settings/Settings';
import Portal from './index';
import PortalLayout from './PortalLayout';

export enum PortalPath {
  ENTRA_ID = '/entraid',
  SETTINGS = '/settings',
}

const PortalRoutes = () => {
  return (
    <Routes>
      <Route path={'/'} element={<Portal />}>
        <Route
          index
          element={
            <PortalLayout>
              <PortalLanding />
            </PortalLayout>
          }
        />
        <Route
          path={PortalPath.SETTINGS}
          element={
            <PortalLayout>
              <Settings />
            </PortalLayout>
          }
        />
        <Route path={PortalPath.ENTRA_ID} element={<Portal />}>
          <Route
            path={'/entraid/auth-success'}
            element={
              <PortalLayout>
                <EntraIdSuccess />
              </PortalLayout>
            }
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default PortalRoutes;
